// Dependencies
import radium from 'radium';

import Button from '../../components/button/Button.tsx';
import ButtonEventsOverview from '../../components/button-events-overview/ButtonEventsOverview.jsx';
import {navigateToEntranceIfGiven} from "../../lib/nav-util-service.js";


function ShoppingCartErrorPage(props) {
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	const eventSpecific = !!props.eventUuid;



	return (
		<div style={style.container}>
			<div style={style.error}>Ihre Sitzung ist leider abgelaufen. < br /> Bitte beginnen Sie den Bestellvorgang erneut.</div>
			{eventSpecific &&
				<Button
					name="to_startpage"
					buttonText="Zur Startseite"
					btnStyle="highlight"
					onClick={() => navigateToEntranceIfGiven(props.eventUuid)}
					buttonContainerStyle={style.buttonContainer}
				/>
			}
			{!eventSpecific &&
				<ButtonEventsOverview
					btnText="Zum Programm"
					buttonContainerStyle={style.buttonContainer}
					iconName="angle-double-left"
				/>
			}
		</div>
	);
}

export default radium(ShoppingCartErrorPage);
